import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { ItemListCell } from '~/components/common';

import { maskId, maskName } from '~/utils/common';

import type { TypeOrders } from '~/types/order.types';

/**
 * [반품 교환 관리] 반품/교환 신청 등록 모달 > 반품/교환 주문 선택 > 테이블 컬럼 정의
 *
 * @note 행 선택(단일)은 No 칸 체크박스로 한다.
 */
const getClaimRegisterOrdersColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeOrders>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
      meta: { selection: true },
    },
    {
      id: 'order.clientOrderCode',
      accessorFn: (data) => data.order?.clientOrderCode,
      header: '판매처 주문번호',
      size: 160,
    },
    {
      id: 'outbound.outboundCode',
      accessorFn: (data) => data.outbound?.outboundCode,
      header: '출고요청번호',
      size: 164,
    },
    {
      id: 'delivery.deliveryDate',
      accessorFn: (data) => data.delivery?.deliveryDate,
      header: '배송예정일',
      size: 100,
      cell: ({ getValue }) => {
        const value = getValue<string | undefined>();
        return value ? value.replaceAll('-', '.') : '-';
      },
    },
    {
      id: 'delivery.operation.name',
      accessorFn: (data) => data.delivery?.operation?.name,
      header: '배송유형',
      size: 80,
    },
    {
      id: 'delivery.courier.name',
      accessorFn: (data) => data.delivery?.courier?.name,
      header: '배송사',
      size: 88,
    },
    {
      id: 'outbound.clusterCenter.name',
      accessorFn: (data) => data.outbound?.clusterCenter?.name,
      header: '생산센터',
      size: 80,
    },
    {
      id: 'order.orderStoreName',
      accessorFn: (data) => data.order?.orderStoreName,
      header: '판매처',
      size: 148,
    },
    {
      id: 'order.paymentAt',
      accessorFn: (data) => data.order?.paymentAt,
      header: '결제완료일시',
      size: 160,
      cell: ({ getValue }) => {
        const value = getValue<string | undefined>();
        return value ? value.replaceAll('-', '.') : '-';
      },
    },
    {
      id: 'receiver.name',
      accessorFn: (data) => data.receiver?.name,
      header: '수령자명',
      size: 100,
      cell: ({ getValue }) => maskName(getValue<string>()),
    },
    {
      id: 'orderer.id',
      accessorFn: (data) => data.orderer?.id,
      header: '주문자 ID',
      size: 140,
      cell: ({ getValue }) => maskId(getValue<string>()),
    },
    {
      id: 'order.orderItems',
      header: '상품명',
      minSize: 240,
      meta: { flex: true },
      cell: ({ row }) => <ItemListCell value={row.original.order?.orderItems} fieldName="itemName" />,
    },
  ];

  return { columnDefs };
};

export default getClaimRegisterOrdersColumnDefs;
